"use client";

import { Select, type SelectOption } from "@leabankab/component-library";
import { FormField } from "@leabankab/component-library/react-hook-form";

interface SelectFieldProps {
	name: string;
	label: string;
	options: readonly SelectOption[];
	placeholder?: string;
	disabled?: boolean;
}

/** The library `Select`, bound to the surrounding react-hook-form form. */
export const SelectField = ({ name, label, ...props }: SelectFieldProps) => (
	<FormField
		name={name}
		render={({ field }) => (
			<Select label={label} {...props} {...field} value={field.value ?? ""} />
		)}
	/>
);
